import { Server } from "miragejs";
import { APPLICATION } from "#/constants";

export function routes(this: Server, token: string) {
  /**
   * @description just a example, you should remove this
   */
  this.get("/time", () => new Date());

  /**
   *@description Authentication Mock routes
   */
  this.post(
    `https://api.${APPLICATION.ENV}-sicredi.in/auth/realms/:issuer/protocol/openid-connect/token`,
    () => ({
      access_token: token,
      id_token: token,
      token_type: "Bearer",
      expires_in: 7200,
      refresh_token: "dummy",
      scope: "dummy",
    })
  );

  this.post(
    `https://api.${APPLICATION.ENV}-sicredi.in/auth/realms/:issuer/sicredi-token-enrichment`,
    () => ({ access_token: token, id_token: token })
  );

  this.get(
    `https://api.${APPLICATION.ENV}-sicredi.in/auth/realms/:issuer/protocol/openid-connect/auth*`,
    (_, req) => {
      const targetRedirection = new URL(
        String(req?.queryParams?.redirect_uri ?? "")
      );
      targetRedirection.searchParams.append("code", "dummy");
      targetRedirection.searchParams.append(
        "scope",
        String(req?.queryParams?.scope ?? "")
      );
      targetRedirection.searchParams.append(
        "state",
        String(req?.queryParams?.state ?? "")
      );
      window.location.replace(targetRedirection.toString());
      return new Response("");
    }
  );

  this.passthrough();
}
